export default __webpack_public_path__ + "4489b3b073f472dab72d002c7a05fdc8.png";